export const ARTICLES_PER_PAGE = 9;
